import { RouteRecordRaw, createRouter, createWebHistory } from 'vue-router';

import Home from '@/views/Home.vue';
import Homepage from '@/views/Homepage/Homepage.vue';

import About from '@/views/About/About.vue';

import Pitões from '@/views/Pitões/Pitoes.vue';

import Portfolio from '@/views/Portfolio/Portfolio.vue';

import Order from '@/views/Order/Order.vue';

import Categories from '@/views/Categories/Categories.vue';

import Flavors from '@/views/Flavors/Flavors.vue';

const routes = [
    {
        path: '/',
        name: 'Home',
        redirect: { name: 'Homepage' },
        component: Home,
        children: [
            {
                path: 'atelier',
                name: 'Homepage',
                component: Homepage,
            },
            {
                path: 'about',
                name: 'About',
                component: About,
            },
            {
                path: 'pitoes',
                name: 'Pitões',
                component: Pitões,
            },
            {
                path: 'portfolio',
                name: 'Portfolio',
                component: Portfolio,
            },
            {
                path: 'order',
                name: 'Order',
                component: Order,
            },
            {
                path: 'categories',
                name: 'Categories',
                component: Categories,
            },
            {
                path: 'sabores',
                name: 'Sabores',
                component: Flavors,
            },
        ],
    },
];

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { top: 0 };
        }
    },
});

export default router;
